import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

/**
 * FAQAccordion — only one item open at a time.
 * Props:
 *   faqs: Array<{ q: string; a: string }>
 */
export default function FAQAccordion({ faqs = [] }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <div className="space-y-3">
      {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return (
          <div
            key={i}
            className={`border-2 rounded-xl overflow-hidden transition-colors duration-200 ${
              isOpen
                ? "border-[#0097b2]/50 shadow-sm"
                : "border-gray-100 hover:border-gray-200"
            }`}
          >
            <button
              className="w-full flex items-center justify-between gap-4 px-6 py-4 text-left"
              onClick={() => toggle(i)}
              aria-expanded={isOpen}
            >
              <span className="font-semibold text-slate-800 text-sm sm:text-base">
                {faq.q}
              </span>
              <ChevronDown
                className={`w-5 h-5 flex-shrink-0 text-[#0097b2] transition-transform duration-300 ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  key="content"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.25, ease: "easeInOut" }}
                >
                  <div className="px-6 pb-5">
                    <p className="text-slate-600 leading-relaxed text-sm sm:text-base">
                      {faq.a}
                    </p>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
